import { makeStyles } from 'tss-react/mui';

const useStylesWidgetImageSliderSimple: MaterialUIStylesCallback = makeStyles()((
  theme: MainTheme,
): MaterialUIStyles => ({
  widgetImageSliderSimpleItem: {
    color: theme.palette.common.white,
    cursor: 'pointer',
    height: 225,
    maxWidth: 500,
    padding: 10,
    [theme.breakpoints.down('md')]: {
      marginTop: 20,
    },
  },
  widgetImageSliderSimpleItemImageBlock: {
    width: '100%',
    height: 'auto',
    minHeight: 205,
    maxHeight: 205,
    overflow: 'hidden',
    textAlign: 'center',
    margin: 'auto 0',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      minHeight: 'auto',
    },
  },
  widgetImageSliderSimpleItemImage: {
    width: 'auto',
    height: 'auto',
    maxHeight: 205,
    maxWidth: 400,
  },
}));

export default useStylesWidgetImageSliderSimple;
